<!--
|--------------------------------------------------
|      询价管理-附件
| 
| 
| 
|--------------------------------------------------
-->
<template>
<div>
    <el-table :data="fileList" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%; margin-bottom:15px" size="mini">
        <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
        </el-table-column>
        <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
            <template slot-scope="scope">
                {{toSize(scope.row.fileSize,null)}}
            </template>
        </el-table-column>
        <el-table-column prop="fileDir" header-align="center" align="center" width="120" label="查看附件">
            <template slot-scope="scope">
                <el-button icon="el-icon-view" type="text" @click="viewHandle(scope.row)">下载</el-button>
            </template>
        </el-table-column>
    </el-table>
</div>
</template>

<script>
// require('@/mock/mockRFQ');

import {
    DIALOG_CLOSED_TYPE,
    SUPPLY_STATUS,
    getLabelByValue,
    TECHNICAL_NOTIFICATION_TYPE,
} from "@/utils/const";
import {
    getFileList,
    uploadFile,
    getUrl
} from '@/controller/sys'
import {
    toFileSize
} from '@/utils'

export default {
    props: {
        //供应商列表数据
        bizId: Number,
        viewFlag: Boolean,
    },
    data() {
        return {
            loading: false,
            fileList: [],
        };
    },
    components: {},
    mounted() {
        this.getFileList()
    },
    methods: {
        async getFileList() {
            if (!this.bizId) return
            // alert(this.basicFormData.bizId)
            try {
                this.loading = true

                const params = {
                    id: this.bizId,
                    bizType: 10,

                }
                const res = await getFileList(params)
                if (res && res.code === '00') {
                    this.fileList = Array.isArray(res.body) ? res.body : []
                } else {
                    this.fileList = []
                }

            } catch (e) {
                console.log(e)
            } finally {
                this.loading = false
            }
        },
        viewHandle(row) {
            const params = {
                fileId: row.id
            }
            getUrl(params).then(data => {
                if (data && data.code === '00' && data.body) {
                    this.download(data.body, row.originalName)
                } else {
                    // this.fileList = []
                }
            })
        },
        download(url, filename) {
            const _this = this
            this.getBlob(url, function (blob) {
                _this.saveAs(blob, filename);
            });
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            } else {
                var link = document.createElement("a")
                var body = document.querySelector("body")

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                // fix Firefox
                link.style.display = "none"
                body.appendChild(link)

                link.click()
                body.removeChild(link)

                window.URL.revokeObjectURL(link.href)
            }
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open("GET", url, true)
            xhr.responseType = "blob"
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            }
            xhr.send()
        },
        supplyStatusFormat(value) {
            if (!value) {
                return "";
            }
            return getLabelByValue(SUPPLY_STATUS, value);
        },
        toSize(byte, format) {
            return toFileSize(byte, format)
        },
    },
};
</script>

<style lang="scss">
</style>
